import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Music from './views/Music.vue'
import User from './views/User.vue'
import Category from './views/Category.vue'
import Singer from './views/Singer.vue'
import Password from './views/Password.vue'
import Album from './views/Album.vue'
import AlbumMusic from './views/AlbumMusic.vue'
import Version from './views/Version.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    //{ path: '/main', component: Main },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-music',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/music', component: Music, name: '歌曲' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-user',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/user', component: User, name: '用户' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-bars',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/category', component: Category, name: '分类' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-id-card-o',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/singer', component: Singer, name: '歌手' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-address-card',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/album', component: Album, name: '歌单' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        hidden: true,
        iconCls: 'fa fa-address-card',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/albumMusic', component: AlbumMusic, name: '歌单歌曲' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-arrow-circle-down',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/version', component: Version, name: '版本' },
        ]
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '导航二',
    //     iconCls: 'fa fa-id-card-o',
    //     children: [
    //         { path: '/page4', component: Page4, name: '页面4' },
    //         { path: '/page5', component: Page5, name: '页面5' }
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '',
    //     iconCls: 'fa fa-address-card',
    //     leaf: true,//只有一个节点
    //     children: [
    //         { path: '/page6', component: Page6, name: '导航三' }
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: 'Charts',
    //     iconCls: 'fa fa-bar-chart',
    //     children: [
    //         { path: '/echarts', component: echarts, name: 'echarts' }
    //     ]
    // },
    {
        path: '/',
        hidden: true,
        name: '',
        component: Home,
        leaf: true,//只有一个节点
        children: [
            { path: '/password', component: Password, name: '修改密码' }
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js